import { Component, OnInit } from '@angular/core';
import { BaseReportActionsDialog } from '../base-report-actions-dialog';
import { GaValidateService } from '../../../formly/ga-validate.service';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../formly/ga-formly.service';
import _ from 'underscore';
import { IObject } from '@type_definitions/datatypes';
import { LOV_PAYMENT_STATUS2, LovService } from '../../../services/lov.service';
import { GaEventService } from '../../../services/ga-event.service';

interface IChangePaymentStatusActionModel {
  paymentStatus?:string;
  paymentDate?:string;
  sendMail:boolean;
}

const STATUS_PAID: string = '9';

@Component({
  selector: 'change-payment-status-action',
  templateUrl: '../../../message/dialogs/default-form-dialog.html'
})
export class ChangePaymentStatusActionComponent extends BaseReportActionsDialog implements OnInit {
  private paymentStatusField: IExtraFieldConfigurationObject;
  public model:IChangePaymentStatusActionModel;

  constructor(
    private formlyService: GaFormlyService,
    private lovService: LovService,
    eventService: GaEventService,
    validateService: GaValidateService
  ) {
    super(eventService, validateService);
  }

  public ngOnInit(): void {
    super.ngOnInit();
    this.model = {
      sendMail: true
    };

    // create fields
    this.fields = this.createFields();

    // fill fields
    this.fillFields();
  }

  private createFields(): IExtraFieldConfigurationObject[] {
    const paymentType = this.getSharedPaymentType(this.rowSelection);
    //depending on the type of input, the actual date will be stored as payment or bank date
    const paymentDateLabel = _.isUndefined(paymentType)? 'Payment/Bank Date' : (paymentType.toLowerCase() === 'credit card'? 'Bank Date' : 'Payment Date');

    return [
      this.paymentStatusField = this.formlyService.aSelect('paymentStatus', 'Payment Status')
        .isRequired()
        .withLabelProp('value')
        .withLabelClass('col-sm-3 nowrap')
        .withValueProp('id')
        .build(),
      this.formlyService.aDateInput('paymentDate', paymentDateLabel)
        .isRequired()
        .withLabelClass('col-sm-3 nowrap')
        .withHideExpression(() => this.model.paymentStatus !== STATUS_PAID)
        .build(),
      this.formlyService.aCheckbox('sendMail', 'Send notification (close payment pending)')
        .withoutWrapper()
        .withWrapperClass('group')
        .withHideExpression(() => this.model.paymentStatus !== STATUS_PAID)
        .build()
    ];
  }

  private fillFields(): void {
    this.formlyService.fillField(this.paymentStatusField, this.lovService.list(LOV_PAYMENT_STATUS2));
  }

  private getSharedPaymentType(rowSelection: IObject[]): string {
    const paymentTypes = _.uniq(_.pluck(rowSelection, 'Depayty_ds'));

    if (paymentTypes.length === 1) {
      return paymentTypes[ 0 ];
    }

    return undefined;
  }
}